import { Text, View } from "@react-pdf/renderer";
import colors from "core/resources/theme/colors";
import React from "react";

function PDFEmptyTable() {
  return (
    <View
      style={{
        paddingVertical: 30,
        alignItems: "center",
        justifyContent: "center",
        flex: 1,
        flexGrow: 1,
      }}
    >
      <Text
        style={{ fontSize: 16, color: colors.darkGray, textAlign: "center" }}
      >
        Nenhum dado para mostrar
      </Text>
    </View>
  );
}

export default PDFEmptyTable;
